import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { DataViewOptions } from '@adornis/data-view/client/data-view-options.js';
import { View } from '@adornis/data-view/db/view.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { StringAspect } from '@adornis/filter/aspect-schemas/StringAspect.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import '@chancenwerk/client/components/chancen-component-card-title.js';
import type { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { workTrackingStateTemplate } from '@chancenwerk/work-tracking/client/data-view.js';
import { WorkTrackingEntry } from '@chancenwerk/work-tracking/entitites/WorkTrackingEntry.js';
import { WorkTrackingTaetigkeitenState } from '@chancenwerk/work-tracking/entitites/WorkTrackingTaetigkeitenState.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/campus-component-teacher-dashboard-lesson-list.js';
import { CampusRoutes } from '../routes.js';
import './campus-page-no-permission.js';

@customElement('campus-page-work-tracking-overview')
export class CampusPageWorkTrackingOverview extends ChemistryLitElement {
  private readonly size = new WindowSizeController(this);

  @state() protected readonly _currentUser = new RXController(this, currentUser<ChancenwerkUser>());

  override styles = () => [
    {
      ':host': {
        // height: '100%',
        width: '100%',
      },
    },
  ];

  override render() {
    return this._content();
  }

  private _content() {
    return html`
      <cr-flex padding="${this.size.mobile ? 'md' : 'lg'}" space="lg">
        <cr-flex space="lg">
          <cr-h2> Taetigkeiten </cr-h2>
        </cr-flex>

        <cr-card space="md" padding="md">
          <cr-data-view
            @entry-clicked=${e => {
              goTo(CampusRoutes.workTracking + '/' + e.detail.entity._id);
            }}
            .options=${{
              class: WorkTrackingEntry,
              view: new View({
                filter: new AdornisFilter({
                  aspects: [new StringAspect({ fieldName: 'userID', value: this._currentUser.value?._id })],
                }),
              }),
              onlyShowLastTranslation: true,
              customColumns: [
                {
                  fieldName: 'stateResponsible',
                  columnName: 'Verwaltung',
                  renderItem: (t: WorkTrackingEntry) => {
                    return workTrackingStateTemplate(this, t.stateResponsible ?? WorkTrackingTaetigkeitenState.OPEN);
                  },
                },
                {
                  fieldName: 'stateContractor',
                  columnName: 'Person',
                  renderItem: (t: WorkTrackingEntry) => {
                    return workTrackingStateTemplate(this, t.stateContractor ?? WorkTrackingTaetigkeitenState.OPEN);
                  },
                },
                {
                  fieldName: 'date',
                  columnName: 'Monat',
                  getFieldMapping: (t: WorkTrackingEntry) => t.date?.toFormat('MM.'),
                },
                {
                  fieldName: 'lastChange',
                  columnName: 'Letzte Änderung',
                  getFieldMapping: (t: WorkTrackingEntry) => t.lastChange?.toFormat('dd.MM.yyyy HH:mm'),
                },
              ],
            } as DataViewOptions<typeof WorkTrackingEntry>}
          >
          </cr-data-view>
        </cr-card>

        <cr-flex w100 ${css({ height: '100px' })}></cr-flex>
      </cr-flex>
    `;
  }
}
